import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import * as Yup from "yup";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Field, Form, Formik, useFormik } from "formik";
import dayjs from "dayjs";
import { updateReportResult } from "../../services/pathLabTestReportService";
import { getLabtestsList } from "../../services/labtestService";
import BasicModal from "../../components/BasicModal";
import FormModalActions from "../../components/FormModalActions";
import {
  DENSE_FIELD_PROPS,
  DENSE_FORM_BODY_SX,
  FORM_MODAL_CONTENT_SX,
} from "../../utils/formModalStyles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const AddNewLabTest = ({ open, onClose, appointment, existingReports }) => {
  const [labtests, setLabTests] = useState({});
  const [labtestsarr, setLabTestArr] = useState([]);

  useEffect(() => {
    fetchLabtests();
  }, []);
  const fetchLabtests = async () => {
    try {
      const data = await getLabtestsList();
      const grouped_data = data.reduce((acc, curr) => {
        const category = curr.category;
        if (!acc[category]) {
          acc[category] = [];
        }
        acc[category].push(curr);
        return acc;
      }, {});
      setLabTests(grouped_data);
      setLabTestArr(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handelCloseModalState = () => {
    onClose();
  };

  const findExistingReportId = (testId) => {
    for (const date in existingReports) {
      const report = existingReports[date].find((r) => r.testId === testId);
      if (report) return report.reportId;
    }
    return null;
  };

  return (
    <BasicModal
      open={open}
      onClose={handelCloseModalState}
      title={`Path Report For ${appointment?.patientName || ""}`}
    >
      <Box sx={{ ...FORM_MODAL_CONTENT_SX, ...DENSE_FORM_BODY_SX }}>
            <Formik
              initialValues={{
                // Dynamically generate the initial values based on your test data
                ...labtestsarr.reduce((acc, curr) => {
                  acc[curr.name] = "";
                  return acc;
                }, {}),
              }}
              // onSubmit={async (values) => {

              //   console.log("🔍 Existing Reports:", existingReports);
                
              //   const reportsByTestId = {};

              //   // Flatten all existing reports by testId
              //   Object.values(existingReports).forEach(reports =>
              //     reports.forEach(report => {
              //       reportsByTestId[report.testId] = report;
              //     })
              //   );

              //   // You can handle form submission here
              //   const ids = [];
              //   labtestsarr.forEach((ele) => {
              //     if (values[ele.name] !== "") {
              //       ids.push({
              //         id: ele.id,
              //         result: values[ele.name],
              //       });
              //     }
              //   });
              //   for (const element of ids) {
              //     try {
              //       const req_data = {
              //         testId: element.id,
              //         patientId: appointment?.patientId,
              //         result: element.result,
              //       };
              //       const data = await updateReport(92, req_data);
              //     } catch (error) {
              //       console.log(error);
              //     }
              //   }
              //   onClose();
              // }}

              onSubmit={async (values) => {
                  const reportsByTestId = {};

                  Object.values(existingReports || {}).forEach((reportArray) => {
                    reportArray.forEach((report) => {
                      const testId = Number(report.testId ?? report.labTestId);
                      if (!Number.isNaN(testId) && testId > 0) {
                        reportsByTestId[testId] = report;
                      }
                    });
                  });

                  for (const test of labtestsarr) {
                    const enteredResult = values[test.name];
                    const matchedReport = reportsByTestId[Number(test.id)];

                    if (enteredResult !== "" && matchedReport?.reportId) {
                      try {
                        const payload = {
                          result: JSON.stringify({ result: String(enteredResult).trim() }),
                          resultStatus: "COMPLETE",
                        };
                        await updateReportResult(matchedReport.reportId, payload);
                        try {
                          const { recordSampleResultEntered } = await import("../../services/sampleTransactionService");
                          await recordSampleResultEntered({
                            prescriptionId: appointment?.prescriptionId ?? matchedReport.prescriptionId,
                            patientId: appointment?.patientId ?? matchedReport.patientId,
                            patientName: appointment?.patientName,
                            labTestId: test.id,
                            labTestName: test.name,
                            billed: true,
                            invoiceId: appointment?.invoiceId ?? matchedReport.invoiceId,
                            reportId: matchedReport.reportId,
                            patientType: "opd",
                            sampleCollected: true,
                            result: true,
                          });
                        } catch (sampleError) {
                          console.warn("[AddNewLabTest] Sample transaction result not saved:", sampleError);
                        }
                      } catch (error) {
                        console.error(`❌ Error updating reportId ${matchedReport.reportId}`, error);
                      }
                    }
                  }

                  onClose();
              }}
            >
              {({ values, handleChange, handleSubmit, isSubmitting }) => (
                <Form onSubmit={handleSubmit}>
                  {Object.entries(labtests).map(([category, fields], index) => (
                    <Accordion key={index}>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="h6" fontWeight={"bold"}>
                          {category}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid container spacing={1}>
                          {fields.map((field) => (
                            <Grid item xs={12} sm={6} md={4} key={field.id}>
                              <Field
                                as={TextField}
                                name={field.name}
                                label={field.name}
                                value={values[field.name]}
                                onChange={handleChange}
                                fullWidth
                                variant="outlined"
                                size="small"
                                margin="dense"
                                helperText={`Reference Value : ${field.referenceValue}`}
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                  <Box mt={2}>
                    <FormModalActions
                      onCancel={handelCloseModalState}
                      submitType="submit"
                      submitDisabled={isSubmitting}
                      loading={isSubmitting}
                    />
                  </Box>
                </Form>
              )}
            </Formik>
      </Box>
    </BasicModal>
  );
};

export default AddNewLabTest;
